function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (game_mod) {
  var _game_mod$respondTo;
  var invite_obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var publicKey = invite_obj.publicKey || null;
  var img = ((_game_mod$respondTo = game_mod.respondTo('arcade-games')) === null || _game_mod$respondTo === void 0 ? void 0 : _game_mod$respondTo.image) || '';
  var title = invite_obj.rom_title || game_mod.returnName();
  var description = invite_obj.rom_title ? game_mod.description || '' : game_mod.description || '';
  var publisher = game_mod.publisher_message ? "<div class=\"publisher\"><span>NOTE:</span> ".concat(game_mod.publisher_message, "</div>") : '';
  var html = "\n    <form class=\"arcade-wizard saito-overlay-panel\">\n      <div class=\"body\">\n        <div class=\"art\">\n          <img class=\"hero\" src=\"".concat(img, "\" alt=\"\">\n        </div>\n        <div class=\"info\">\n          <div class=\"title\">").concat(title, "</div>\n          <div class=\"description\">").concat(description, "</div>\n          ").concat(publisher, "\n        </div>\n        <input type=\"hidden\" name=\"game\" value=\"").concat(game_mod.name, "\" />\n        <div class=\"settings\">\n          ").concat(game_mod.returnOptions(), "\n          <div id=\"arcade-advance-opt\">\n            <button type=\"button\" class=\"advanced-btn saito-button-secondary\" aria-label=\"advanced options\">\n              <i class=\"fa-solid fa-gear\" aria-hidden=\"true\"></i>\n              <span>advanced</span>\n            </button>\n          </div>\n        </div>\n        <div class=\"actions\">\n  ");
  if (game_mod.maxPlayers == 1) {
    html += "\n      <div class=\"invite-control\">\n        <button type=\"button\" id=\"game-invite-btn\" class=\"fat saito-button-primary invite-primary game-invite-btn\" data-type=\"single\">\n          Play\n        </button>\n      </div>\n    ";
  } else {
    var invite_options = [];
    if (publicKey) {
      invite_options.push({
        type: 'direct',
        label: 'Next…'
      });
    } else if (invite_obj.league) {
      invite_options.push({
        type: 'open',
        label: 'CREATE PUBLIC INVITE'
      }, {
        type: 'private',
        label: 'CREATE PRIVATE INVITE'
      });
    } else {
      invite_options.push({
        type: 'open',
        label: 'CREATE PUBLIC INVITE'
      }, {
        type: 'private',
        label: 'CREATE PRIVATE INVITE'
      });
      if (game_mod !== null && game_mod !== void 0 && game_mod.can_play_async) {
        invite_options.push({
          type: 'async',
          label: 'CREATE ASYNC INVITE'
        });
      }
    }
    var primary = invite_options[0];
    html += "\n      <div class=\"invite-control\">\n        <button type=\"button\" class=\"fat saito-button-primary invite-primary game-invite-btn\" data-type=\"".concat(primary.type, "\">\n          ").concat(primary.label, "\n        </button>\n    ");
    if (invite_options.length > 1) {
      html += "\n        <button type=\"button\" class=\"invite-toggle\" aria-label=\"Choose invite type\" aria-expanded=\"false\" aria-haspopup=\"listbox\">\n          <span aria-hidden=\"true\">\u25BE</span>\n        </button>\n        <div class=\"invite-menu\" role=\"listbox\" hidden>\n      ";
      var _iterator = _createForOfIteratorHelper(invite_options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var opt = _step.value;
          html += "\n          <button type=\"button\" class=\"invite-option\" data-type=\"".concat(opt.type, "\" role=\"option\">\n            ").concat(opt.label, "\n          </button>\n        ");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      html += "</div>";
    }
    html += "</div>";
  }
  html += "\n        </div>\n      </div>\n    </form>\n  ";
  return html;
};